// extracted by mini-css-extract-plugin
export default {"spinnerOverlay":"Loader_spinnerOverlay__yzd5b","fadeIn":"Loader_fadeIn__TFWn0","fadeOut":"Loader_fadeOut__PWS8E"};